// tenant-portal は契約機能のハブ画面。深い画面は無く、外部 apps への
// 遷移が中心なので route 数は最小（home + signIn のみ）。
export const ROUTES = {
  home: '/',
  signIn: '/signin',
  /** TP-20: お支払い（クレジットカード登録）。テナント自身が自テナントのカードを登録。 */
  billing: '/billing',
  /** N-15b: 通知先登録（管理者向け通知の受信者名簿）。 */
  notificationRecipients: '/notification-recipients',
} as const;
